import React from "react";
import css from "./SectionView.module.css";
import {TerminalView,TextView,NoticeView,Title} from "Components";


export default function SectionView(props){
    const {title,titleStyle,text,notice,cli}=props;
    return (
        <section className={css.sectionview+" "+(props.className||"")} style={props.style}>
            {title&&<Title title={title} style={titleStyle}/>}
            {text&&<TextView text={text}/>}
            {notice&&<NoticeView {...(typeof(notice)==="string"?{text:notice}:notice)}/>}
            {cli&&<TerminalView {...cli}/>}
            {props.children}
        </section>
    )
}
